import React, { useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import "../ContactUs/ContactUs.css";
import { ContactUsData } from "../../Data/Data";
import axios from "../../utils/axiosConfig";

const ContactUs = () => {

  const [captcha, setCaptcha] = useState(null);

  const data = ContactUsData[0];

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    phone: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState("");

  const validate = () => {
    let err = {};

    if (!formData.name) err.name = "Name is required";
    if (!formData.subject) err.subject = "Subject is required";

    if (!formData.email) {
      err.email = "Email is required";
    } else if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
      err.email = "Invalid Email";
    }

    if (!formData.phone) {
      err.phone = "Phone is required";
    } else if (!/^[0-9]+$/.test(formData.phone)) {
      err.phone = "Only numbers allowed";
    }

    return err;
  };

  const handleChange = (e) => {
    let value = e.target.value;

    if (e.target.name === "name" || e.target.name === "subject") {
      value = value.toUpperCase();
    }

    if (e.target.name === "phone") {
      value = value.replace(/[^0-9]/g, "");
    }

    setFormData({ ...formData, [e.target.name]: value });
  };

  const handleSubmit = async (e) => {

    if (!captcha) {
      alert("Please verify captcha");
      return;
    }

    e.preventDefault();

    const err = validate();
    setErrors(err);

    if (Object.keys(err).length === 0) {
      try {
        // await axios.post("/api/contact", formData);
        await axios.post("/api/contact", {
          ...formData,
          captcha: captcha
        });

        setSuccess("Message sent successfully ✅");

        setFormData({
          name: "",
          email: "",
          subject: "",
          phone: "",
          message: "",
        });

        setTimeout(() => setSuccess(""), 3000);

      } catch (error) {
        console.error(error);
        setSuccess("Server error ❌");
      }
    }
  };

  const handleReset = () => {
    setFormData({
      name: "",
      email: "",
      subject: "",
      phone: "",
      message: "",
    });
    setErrors({});
  };

  return (
    <div className="contact-wrapper">

      {/* SUCCESS TOAST */}
      {success && <div className="success-toast">{success}</div>}

      <div className="contact-header text-center">
        <h1>CONTACT US</h1>
        <p>
          We'd love to hear from you — Reach out anytime for queries, admissions, or support.
        </p>
      </div>

      <div className="container">
        <div className="row g-4">

          <div className="col-lg-7">
            <div className="contact-card form-card">
              <h3 className="card-title">Send Your Query</h3>

              <form onSubmit={handleSubmit}>
                <div className="row g-3">

                  <div className="col-md-6">
                    <div className="floating-group">
                      <input type="text" name="name" value={formData.name} onChange={handleChange} />
                      <label>Name</label>
                    </div>
                    {errors.name && <small className="error">{errors.name}</small>}
                  </div>

                  <div className="col-md-6">
                    <div className="floating-group">
                      <input type="text" name="email" value={formData.email} onChange={handleChange} />
                      <label>Email</label>
                    </div>
                    {errors.email && <small className="error">{errors.email}</small>}
                  </div>

                  <div className="col-md-6">
                    <div className="floating-group">
                      <input type="text" name="subject" value={formData.subject} onChange={handleChange} />
                      <label>Subject</label>
                    </div>
                    {errors.subject && <small className="error">{errors.subject}</small>}
                  </div>

                  <div className="col-md-6">
                    <div className="floating-group">
                      <input type="text" name="phone" value={formData.phone} onChange={handleChange} />
                      <label>Phone</label>
                    </div>
                    {errors.phone && <small className="error">{errors.phone}</small>}
                  </div>

                  <div className="col-12">
                    <div className="floating-group">
                      <textarea rows="4" name="message" value={formData.message} onChange={handleChange}></textarea>
                      <label>Message</label>
                    </div>
                  </div>

                  <div style={{ marginTop: "20px" }}>
                    <ReCAPTCHA
                      sitekey="6Lf7oNMsAAAAAETiWwBj-narLfqUej71jqWTPnBW"
                      onChange={(value) => setCaptcha(value)}
                    />
                  </div>
                  <div className="col-12 d-flex gap-3 btn-group-custom">
                    <button className="btn send-btn">Send Message</button>
                    <button type="button" className="btn reset-btn" onClick={handleReset}>
                      Reset
                    </button>
                  </div>

                </div>
              </form>
            </div>
          </div>

          {/* INFO SAME */}
          <div className="col-lg-5">
            <div className="contact-card info-card">
              <h4>Get in touch</h4>

              <div className="info-item">
                <i className="bi bi-geo-alt-fill"></i>
                <div>
                  <strong>{data.schoolName}</strong>
                  <p>{data.address}</p>
                </div>
              </div>

              <div className="info-item">
                <i className="bi bi-telephone-fill"></i>
                <div>
                  <strong>Contact</strong>
                  {data.phone.map((p, i) => <p key={i}>{p}</p>)}
                </div>
              </div>

              <div className="info-item">
                <i className="bi bi-envelope-fill"></i>
                <div>
                  <strong>Email</strong>
                  <p>{data.email}</p>
                </div>
              </div>

              <div className="info-item">
                <i className="bi bi-globe"></i>
                <div>
                  <strong>Website</strong>
                  <p>{data.website}</p>
                </div>
              </div>
            </div>
          </div>

        </div>

        <div className="map-box mt-5"> 
          <iframe 
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3442.8841041213695!2d78.01922537437054!3d30.35424350382828!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3908d78054dca483%3A0x90f86ee41f017467!2sNorthPoint%20Children&#39;s%20Academy!5e0!3m2!1sen!2sin!4v1777202614320!5m2!1sen!2sin"
            loading="lazy"
            title="North Point Children's Academy"
          ></iframe>
        </div>

       </div>
    </div>
  );
};

export default ContactUs;